<script>
const icons = {
  'map-pin': [
    { tag: 'path', attrs: { d: 'M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z' }},
    { tag: 'circle', attrs: { cx: '12', cy: '10', r: '3' }}
  ],
  map: [
    { tag: 'path', attrs: { d: 'm3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3z' }},
    { tag: 'path', attrs: { d: 'M9 3v15M15 6v15' }}
  ],
  'arrow-left': [
    { tag: 'path', attrs: { d: 'm12 19-7-7 7-7M19 12H5' }}
  ],
  dashboard: [
    { tag: 'rect', attrs: { width: '7', height: '9', x: '3', y: '3', rx: '1' }},
    { tag: 'rect', attrs: { width: '7', height: '5', x: '14', y: '3', rx: '1' }},
    { tag: 'rect', attrs: { width: '7', height: '9', x: '14', y: '12', rx: '1' }},
    { tag: 'rect', attrs: { width: '7', height: '5', x: '3', y: '16', rx: '1' }}
  ],
  'file-text': [
    { tag: 'path', attrs: { d: 'M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z' }},
    { tag: 'path', attrs: { d: 'M14 2v6h6M8 13h8M8 17h8M8 9h2' }}
  ],
  ticket: [
    { tag: 'path', attrs: { d: 'M2 9a3 3 0 0 0 0 6v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3a3 3 0 0 1 0-6V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z' }},
    { tag: 'path', attrs: { d: 'M13 5v2M13 11v2M13 17v2' }}
  ],
  calendar: [
    { tag: 'rect', attrs: { width: '18', height: '18', x: '3', y: '4', rx: '2' }},
    { tag: 'path', attrs: { d: 'M16 2v4M8 2v4M3 10h18' }}
  ],
  files: [
    { tag: 'path', attrs: { d: 'M20 7h-9a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z' }},
    { tag: 'path', attrs: { d: 'M16 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h4' }}
  ],
  settings: [
    { tag: 'path', attrs: { d: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z' }},
    { tag: 'path', attrs: { d: 'm19.4 15 .1.1 1.4 1.1-1.4 2.4-1.7-.7a8 8 0 0 1-1.5.9l-.3 1.8h-2.8l-.3-1.8a8 8 0 0 1-1.5-.9l-1.7.7-1.4-2.4 1.4-1.1a7 7 0 0 1 0-1.8l-1.4-1.1 1.4-2.4 1.7.7a8 8 0 0 1 1.5-.9l.3-1.8h2.8l.3 1.8a8 8 0 0 1 1.5.9l1.7-.7 1.4 2.4-1.4 1.1a7 7 0 0 1 0 1.7Z' }}
  ],
  sliders: [
    { tag: 'line', attrs: { x1: '4', x2: '4', y1: '21', y2: '14' }},
    { tag: 'line', attrs: { x1: '4', x2: '4', y1: '10', y2: '3' }},
    { tag: 'line', attrs: { x1: '12', x2: '12', y1: '21', y2: '12' }},
    { tag: 'line', attrs: { x1: '12', x2: '12', y1: '8', y2: '3' }},
    { tag: 'line', attrs: { x1: '20', x2: '20', y1: '21', y2: '16' }},
    { tag: 'line', attrs: { x1: '20', x2: '20', y1: '12', y2: '3' }},
    { tag: 'line', attrs: { x1: '2', x2: '6', y1: '14', y2: '14' }},
    { tag: 'line', attrs: { x1: '10', x2: '14', y1: '8', y2: '8' }},
    { tag: 'line', attrs: { x1: '18', x2: '22', y1: '16', y2: '16' }}
  ],
  truck: [
    { tag: 'path', attrs: { d: 'M10 17h4V5H2v12h3M14 9h4l4 4v4h-3' }},
    { tag: 'circle', attrs: { cx: '7.5', cy: '17.5', r: '2.5' }},
    { tag: 'circle', attrs: { cx: '16.5', cy: '17.5', r: '2.5' }}
  ],
  gauge: [
    { tag: 'path', attrs: { d: 'm12 14 4-4M20.2 15A9 9 0 1 1 18 6.3' }},
    { tag: 'path', attrs: { d: 'M22 12A10 10 0 0 0 12 2v10z' }}
  ],
  route: [
    { tag: 'circle', attrs: { cx: '6', cy: '19', r: '3' }},
    { tag: 'path', attrs: { d: 'M9 19h8.5a3.5 3.5 0 0 0 0-7H6.5a3.5 3.5 0 0 1 0-7H9' }},
    { tag: 'circle', attrs: { cx: '18', cy: '5', r: '3' }}
  ],
  book: [
    { tag: 'path', attrs: { d: 'M12 7v14M3 18V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-7l-3 2-3-2H5a2 2 0 0 1-2-2Z' }},
    { tag: 'path', attrs: { d: 'M8 7h8M8 11h8' }}
  ],
  bot: [
    { tag: 'path', attrs: { d: 'M12 8V4H8' }},
    { tag: 'rect', attrs: { width: '16', height: '12', x: '4', y: '8', rx: '2' }},
    { tag: 'path', attrs: { d: 'M2 14h2M20 14h2M9 13v2M15 13v2' }}
  ],
  car: [
    { tag: 'path', attrs: { d: 'M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2' }},
    { tag: 'circle', attrs: { cx: '7', cy: '17', r: '2' }},
    { tag: 'path', attrs: { d: 'M9 17h6' }},
    { tag: 'circle', attrs: { cx: '17', cy: '17', r: '2' }}
  ],
  grip: [
    { tag: 'circle', attrs: { cx: '5', cy: '5', r: '1' }},
    { tag: 'circle', attrs: { cx: '12', cy: '5', r: '1' }},
    { tag: 'circle', attrs: { cx: '19', cy: '5', r: '1' }},
    { tag: 'circle', attrs: { cx: '5', cy: '12', r: '1' }},
    { tag: 'circle', attrs: { cx: '12', cy: '12', r: '1' }},
    { tag: 'circle', attrs: { cx: '19', cy: '12', r: '1' }},
    { tag: 'circle', attrs: { cx: '5', cy: '19', r: '1' }},
    { tag: 'circle', attrs: { cx: '12', cy: '19', r: '1' }},
    { tag: 'circle', attrs: { cx: '19', cy: '19', r: '1' }}
  ],
  'id-card': [
    { tag: 'path', attrs: { d: 'M13 19a4 4 0 0 0-8 0' }},
    { tag: 'path', attrs: { d: 'M16 10h2' }},
    { tag: 'path', attrs: { d: 'M16 14h2' }},
    { tag: 'circle', attrs: { cx: '9', cy: '12', r: '3' }},
    { tag: 'rect', attrs: { x: '2', y: '5', width: '20', height: '14', rx: '2' }}
  ],
  users: [
    { tag: 'path', attrs: { d: 'M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M16 3.1a4 4 0 0 1 0 7.8M20 21v-2a4 4 0 0 0-3-3.9' }},
    { tag: 'circle', attrs: { cx: '10', cy: '7', r: '4' }}
  ],
  'user-round': [
    { tag: 'circle', attrs: { cx: '12', cy: '8', r: '5' }},
    { tag: 'path', attrs: { d: 'M20 21a8 8 0 0 0-16 0' }}
  ],
  'user-round-clock': [
    { tag: 'circle', attrs: { cx: '12', cy: '8', r: '5' }},
    { tag: 'path', attrs: { d: 'M20 21a8 8 0 0 0-16 0' }},
    { tag: 'circle', attrs: { cx: '19', cy: '17', r: '3' }},
    { tag: 'path', attrs: { d: 'M19 15.5v1.5l1 1' }}
  ],
  'map-pinned': [
    { tag: 'path', attrs: { d: 'M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0' }},
    { tag: 'path', attrs: { d: 'M4.474 15h-.197a1 1 0 0 0-.969.753l-1.097 4.35a1.5 1.5 0 0 0 1.444 1.898L20.344 22a1.5 1.5 0 0 0 1.446-1.897l-1.098-4.35a1 1 0 0 0-.969-.753h-.197' }},
    { tag: 'circle', attrs: { cx: '12', cy: '8', r: '2' }}
  ],
  bell: [
    { tag: 'path', attrs: { d: 'M10.268 21a2 2 0 0 0 3.464 0' }},
    { tag: 'path', attrs: { d: 'M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326' }}
  ],
  wrench: [
    { tag: 'path', attrs: { d: 'M14.7 6.3a6 6 0 0 0-8.4 8.4l-4.1 4.1a2 2 0 0 0 2.8 2.8l4.1-4.1a6 6 0 0 0 8.4-8.4L13 13.5 10.5 11z' }}
  ],
  note: [
    { tag: 'path', attrs: { d: 'M8 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M8 3v5h5M8 3l5 5M8 13h8M8 17h5' }},
    { tag: 'path', attrs: { d: 'm16 5 3 3M14 10l7-7 2 2-7 7-3 1z' }}
  ],
  logout: [
    { tag: 'path', attrs: { d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9' }}
  ]
}

export default {
  name: 'LucideIcon',
  functional: true,
  props: {
    name: {
      type: String,
      required: true
    }
  },
  render(h, context) {
    const shapes = icons[context.props.name] || []
    return h('svg', {
      class: ['sidebar-lucide-icon', 'lucide-icon', context.data.staticClass, context.data.class],
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'aria-hidden': 'true'
      }
    }, shapes.map(shape => h(shape.tag, { attrs: shape.attrs })))
  }
}
</script>
